/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Common_Sign_Sign_Up_TitleInputs */

const en_common_sign_sign_up_title = /** @type {(inputs: Common_Sign_Sign_Up_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Sign Up`)
};

/**
* | output |
* | --- |
* | "Sign Up" |
*
* @param {Common_Sign_Sign_Up_TitleInputs} inputs
* @param {{ locale?: "en" }} options
* @returns {LocalizedString}
*/
const common_sign_sign_up_title = /** @type {((inputs?: Common_Sign_Sign_Up_TitleInputs, options?: { locale?: "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Common_Sign_Sign_Up_TitleInputs, { locale?: "en" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return en_common_sign_sign_up_title(inputs)
});
export { common_sign_sign_up_title as "common.sign.sign_up_title" }